import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@shared/infrastructure/services/http/base-http.service';
import { environment } from '@env/environment';
import { ApiResponse } from '@features/wallet/infrastructure/dtos/wallet.api.dto';

@Injectable({
  providedIn: 'root'
})
export class WalletGateway extends BaseHttpService {
  protected readonly baseUrl = environment.apiURL;

  getWallet(params: { code: string; eventId: string; organizationId: string }): Observable<ApiResponse> {
    return this.get<ApiResponse>('/ticket-event-wallet', params);
  }
}
